import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { notifyUser, normalizeGhanaPhone, validateGhanaPhone } from "../../../util/util";
import { extractErrorMessage } from '../../../hooks/extractErrorMessage';
import { authApi } from "../../../services/auth.service";
import { Spin } from "antd";

export default function EnterPhoneForOtp() {
  const navigate = useNavigate();
  const params = useParams();
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [mounted, setMounted] = useState(false);

  // Autofill phone from params (if not '0'), but only if user hasn't typed yet
  useEffect(() => {
    if (!phone && params.phone && params.phone !== '0') {
      setPhone(params.phone);
    }
    // else, do not override what user has typed
  }, [params.phone, phone]);

  // Delay rendering of omk-text-field until after mount
  useEffect(() => {
    setMounted(true);
  }, []);

  // Using centralized phone utilities from util.js

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Normalize phone number (handles 05XXXXXXXX → 233XXXXXXXX)
    const normalized = normalizeGhanaPhone(phone);
    const validation = validateGhanaPhone(normalized);
    
    if (!validation.isValid) {
      notifyUser('error', validation.error, 'Validation Error');
      return;
    }
    
    setLoading(true);
    try {
      const response = await authApi.resendOtp(normalized);
      notifyUser('success', response.data?.message || 'OTP sent to your phone.', 'Success');
      
      // Check if API returns otp_ref in response
      const otpRef = response.data?.data?.otp_ref;
      navigate('/onboard/phone-otp', { 
        state: { 
          phone: normalized,
          otpRef: otpRef // Pass otp_ref if available
        } 
      });
    } catch (e) {
      notifyUser('error', extractErrorMessage(e, 'Failed to send OTP'), 'Error');
    }
    setLoading(false);
  };

  return (
    <div className="mx-auto mobile-full-width shadow bg-white p-5 rounded login-width">
      <div align="center">
        <p className="lead fw-bold">Enter Your Phone Number</p>
        <p style={{ color: '#b22222', fontWeight: 500, marginBottom: 20 }}>
          Your phone number is not verified. Kindly enter your phone number to receive OTP for validation.
        </p>
        <form onSubmit={handleSubmit} style={{ maxWidth: 340, margin: '0 auto' }}>
          <div className="mt-4 w-75 mx-auto mobile-full-width">
            <Spin spinning={loading}>
              {mounted && (
                <omk-text-field
                  label="Phone Number"
                  value={typeof phone === 'string' ? phone : ''}
                  type="tel"
                  class="mb-4"
                  onInput={e => {
                    // Normalize as user types (handles 05XXXXXXXX → 233XXXXXXXX)
                    const normalized = normalizeGhanaPhone(e.target.value);
                    setPhone(normalized);
                  }}
                  name="phone"
                  placeholder="05XXXXXXXX or 233XXXXXXXXX"
                  style={{ marginBottom: '20px', borderRadius: '50px', padding: '10px', width: '100%', maxWidth: 320 }}
                  required
                  maxlength="12"
                />
              )}
              <button
                className="btn btn-primary mb-4 w-75"
                type="submit"
                disabled={loading}
              >
                {loading ? 'Sending OTP...' : 'Send OTP'}
              </button>
            </Spin>
          </div>
        </form>
      </div>
    </div>
  );
}
